import { render, staticRenderFns } from "./dept-edit.vue?vue&type=template&id=e28938b6&scoped=true&"
import script from "./dept-edit.vue?vue&type=script&lang=js&"
export * from "./dept-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28938b6",
  null
  
)

export default component.exports